var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{attrs:{"title":_vm.fvalue.title,"description":_vm.fvalue.description,"type":_vm.type,"show-icon":_vm.showIcon,"closable":_vm.closable,"center":_vm.center,"effect":_vm.effect}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }